module.exports = __webpack_public_path__ + "public/base/error/theme/default/images/error-401.png";


//////////////////
// WEBPACK FOOTER
// ./public/base/error/theme/default/images/error-401.png
// module id = 307
// module chunks = 0